<div
  class="d-flex align-items-center form-title mt-2 mb-2"
  [ngClass]="(themeService.isLight$ | async) ? 'light' : 'dark'"
>
  <div class="d-flex align-items-center p-2">
    <img class="section-image" [src]="icon || '../../assets/icon/article.svg'" [attr.alt]="title || 'section-icon'" />
  </div>
  <div class="form-title-text-container">
    <p class="my-0 py-0" [ngClass]="(themeService.isLight$ | async) ? 'light' : 'dark'">
      {{ title || ('ODV_DOCUMENTS_FORM.TEMPLATE' | translate) }}
    </p>
  </div>
</div>
